export const LEAD_CAROUSEL_PLACEMENT = {
    TOP: 'SERP_HITS_TOP_PLACEMENT',
    MIDDLE: 'SERP_HITS_MIDDLE_PLACEMENT',
    BOTTOM: 'SERP_HITS_BOTTOM_PLACEMENT',
    HIDE: 'SERP_HITS_HIDE'
};

export const EdapCarouselPlacementsMap = {
    SERP_HITS_TOP_PLACEMENT: 'top',
    SERP_HITS_MIDDLE_PLACEMENT: 'middle',
    SERP_HITS_BOTTOM_PLACEMENT: 'bottom'
};

export const EdapCarouselNames = {
    SERP_PREVIOUSLY_VIEWED_CAROUSEL: 'recently_viewed_carousel',
    SERP_AMENITIES_CAROUSEL: 'popular_amenities',
    SERP_FLEX_DATES_CAROUSEL: 'flex_dates_carousel'
};

export const SERP_PREVIOUSLY_VIEWED_CAROUSEL =
    'SERP_PREVIOUSLY_VIEWED_CAROUSEL';
export const SERP_AMENITIES_CAROUSEL = 'SERP_AMENITIES_CAROUSEL';
export const SERP_FLEX_DATES_CAROUSEL = 'SERP_FLEX_DATES_CAROUSEL';
